import React from 'react';
import ShortTextIcon from '@mui/icons-material/ShortText';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import GavelIcon from '@mui/icons-material/Gavel';
import ImageIcon from '@mui/icons-material/Image';
import StarIcon from '@mui/icons-material/Star';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CelebrationIcon from '@mui/icons-material/Celebration';
import {QuestionType} from "crqlar-react-common/dist/models/forms/form";

// Get the appropriate icon for a question type
export const getQuestionTypeIcon = (type: QuestionType) => {
    switch (type) {
        case QuestionType.WELCOME:
            return <OndemandVideoIcon sx={{ color: '#4FD1C5' }} />;
        case QuestionType.MULTIPLE_CHOICE:
            return <CheckBoxOutlineBlankIcon sx={{ color: '#D53F8C' }} />;
        case QuestionType.PICTURE_CHOICE:
            return <ImageIcon sx={{ color: '#805AD5' }} />;
        case QuestionType.YES_NO:
            return <ToggleOnIcon sx={{ color: '#B794F4' }} />;
        case QuestionType.DROPDOWN:
            return <ArrowDropDownCircleIcon sx={{ color: '#90CDF4' }} />;
        case QuestionType.LEGAL:
            return <GavelIcon sx={{ color: '#90CDF4' }} />;
        case QuestionType.SHORT_TEXT:
            return <ShortTextIcon sx={{ color: '#63B3ED' }} />;
        case QuestionType.LONG_TEXT:
            return <TextFieldsIcon sx={{ color: '#63B3ED' }} />;
        case QuestionType.RATING:
            return <StarIcon sx={{ color: '#F6AD55' }} />;
        case QuestionType.UPLOAD_MEDIA:
            return <CloudUploadIcon sx={{ color: '#48BB78' }} />;
        case QuestionType.END_SCREEN:
            return <CelebrationIcon sx={{ color: '#F6AD55' }} />;
        default:
            return <ShortTextIcon sx={{ color: '#63B3ED' }} />;
    }
};